module.exports = __webpack_public_path__ + "img/m_logo_springsoft.283b840f.png";